import PropTypes from 'prop-types';
import {useEffect, useRef} from 'react';
import {connect} from 'react-redux';
import {
  recordBigQueryEvent,
  setErrorOnPage,
  submitConfirm,
  updateThreeDSecureDataForChallengeIframe,
} from '../../../actions/paymentActions/threedsActions';
import Translation from '../../../lang/Translation';
import {getSettings, getSiteCode} from '../../../selectors/selectors';
import Track from '../../../utils/tracking';
import PostToIframe from '../ProviderAgnostic/PostToIframe';
import useStyles from '../ThreeDSecure.styles';

export function Nuvei3DSChallenge(props) {
  const classes = useStyles();
  const timer = useRef(null);
  
  const PROVIDER = 'NUVEI';
  
  useEffect(() => {
    try {
      recordBigQueryEvent('2ChallengeRequired', PROVIDER);
    } catch (error) {
      Track.track(error);
    }
    timer.current = setTimeout(() => {
      try {
        recordBigQueryEvent('DataCollectionCompleted', PROVIDER, [{name: 'result', value: 'timeout'}], []);
      } catch (error) {
        Track.track(error);
      }
      
      props.submitConfirm(props.providerTransactionId);
    }, 600000);
    
    return () => {
      clearTimeout(timer.current);
      props.updateThreeDSecureDataForChallengeIframe({});
    }; // when component unmount
  }, []);
  
  const handleOnError = () => {
    clearTimeout(timer);
    const errorMessage = 'Error loading Nuvei 3DS Challenge frame';
    Track.track(new Error(errorMessage));
    props.setErrorOnPage();
    props.submitConfirm(props.providerTransactionId);
    try {
      recordBigQueryEvent('2ChallengeCompleted', PROVIDER,
        [{name: 'result', value: 'error'}], [{type: 'loading', value: errorMessage}]);
    } catch (error) {
      Track.track(error);
    }
  };
  
  const handleOnLoad = () => {
    try {
      recordBigQueryEvent('2ChallengeInitiated', PROVIDER);
    } catch (error) {
      Track.track(error);
    }
  };
  
  return (
    <div className={classes.ThreeDSecureContainer} data-test="Nuvei3DSChallenge">
      
      {props.showHelpText && (
        <p data-test="Nuvei3DSChallenge__text">
          <Translation optionalExtension={props.siteCode}>nuvei.help.text</Translation>
        </p>
      )}
      
      <PostToIframe
        postURL={props.issuerURL}
        formFields={{
          creq: props.oneTime3DSToken,
        }}
        onError={handleOnError}
        onLoad={handleOnLoad}
      />
    </div>
  );
}

Nuvei3DSChallenge.propTypes = {
  oneTime3DSToken: PropTypes.string.isRequired,
  issuerURL: PropTypes.string.isRequired,
  providerTransactionId: PropTypes.string,
  showHelpText: PropTypes.bool.isRequired,
  siteCode: PropTypes.string.isRequired,
  setErrorOnPage: PropTypes.func.isRequired,
  submitConfirm: PropTypes.func.isRequired,
  updateThreeDSecureDataForChallengeIframe: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  showHelpText: !!getSettings(state)?.show_nuvei_3ds_challenge_help_text,
  siteCode: getSiteCode(state),
});

export default connect(mapStateToProps, {setErrorOnPage, submitConfirm, updateThreeDSecureDataForChallengeIframe})(Nuvei3DSChallenge);
